import React, { useState } from "react";
import BottomBorder from "./bottomBorder/bottomborder";
import TimelineSetting from "./timelineSetting/timelineSetting";
import LayersWrappers from "./layersWrapper/layersWrappers";
import Timeline from "./timline/Timeline";
import { Rnd } from "react-rnd";

export const Bottom = (props) => {
  return (
    <div className="bottom" style={{ height: 250 + "px" }} id="TimelineWrapper">
      <Rnd
        default={{
          x: 0,
          y: 0,
          width: "100%",
          height: 250,
        }}
        style={{ background: "#f0f1f5" }}
        className="tm-resize"
        enableResizing={{
          top: true,
          right: false,
          bottom: false,
          left: false,
          topRight: false,
          bottomRight: false,
          bottomLeft: false,
          topLeft: false,
        }}
        disableDragging={true}
        maxHeight="350px"
        minHeight="96px"
        onResize={(e, dir, refToElement, delta, position) => {
          //setHeight(refToElement.offsetHeight)
          refToElement.parentElement.style.height =
            refToElement.offsetHeight + "px";
          refToElement.style.transform = "translate(0px, 0px)";

          document.getElementById("leftEditorPanel").style.height =
            "calc((100% - " + refToElement.parentElement.offsetHeight + "px)";
          document.getElementsByClassName("tdStyle3")[0].style.height =
            "calc(100%  - " + refToElement.parentElement.offsetHeight + "px)";
          // document.getElementsByClassName("tdStyle3")[0].style.top =
          //   "-" + refToElement.parentElement.offsetHeight + "px";
          document.getElementsByClassName("EditorParent")[0].style.height =
            "calc( 100% - " + refToElement.parentElement.offsetHeight + "px)";

          let HeightDiff =
            document.getElementsByClassName("EditorParent")[0].offsetHeight -
            document.getElementsByClassName("EditorTrackerStart")[0]
              .offsetHeight;

          if (HeightDiff > 0) {
            let requireMargin = HeightDiff / 2;
            document.getElementsByClassName(
              "EditorTrackerStart"
            )[0].style.marginTop = requireMargin + "px";
          }
        }}
      >
        <BottomBorder />
        <TimelineSetting />
        <LayersWrappers setTimelineZoomVal={props.setTimelineZoomVal} />
        <Timeline
          unitWidth={props.unitWidth}
          perUnitMS={props.perUnitMS}
          calculateTimeByWidth={props.calculateTimeByWidth}
        />
      </Rnd>
    </div>
  );
};
export default Bottom;
